<div style="height:100%;height:100vh;width:100vw;margin:0;padding:0;border:solid 2px red;"><home-comp [config]="config"></home-comp></div>